import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CartItem, CartItemType } from '../cart.model';
import { LayerType } from "../../../../../../../api/src/creative-unit-package/models/layer/layer.dto";
import { CartService } from "../cart.service";

@Component({
	selector: 'app-cart-list-item-row',
	templateUrl: './cart-list-item-row.component.html',
	styleUrls: ['./cart-list-item-row.component.scss']
})
export class CartListItemRowComponent {
	readonly LayerType = LayerType;
	readonly CartItemType = CartItemType;

	@Input() item: CartItem;
	@Input() mode: 'list' | 'checkout' | 'post-checkout'; // Determines the template being used.
	@Input() showDelete = true;
	@Input() showReview = true;
	@Input() useItemTranslation: boolean = false; // Use when we are not handling a real item, but a preview.
	@Input() highlightQuery: string; // Highlight a regex match in the group/item names
	@Input() actionInProgress: {group?: any, itemIds?: string[]} | null;

	@Output() goToItem: EventEmitter<CartItem> = new EventEmitter<CartItem>();
	@Output() itemAction = new EventEmitter<{action: string, item: CartItem}>();
	@Output() deleteItem = new EventEmitter<CartItem>();

	constructor(
		public readonly projectCartService: CartService
	) { }

	onItemAction(action: string) {
		this.itemAction.emit({action, item: this.item});
	}

}
